import AuthDialog from "../../../../public_html/src/js/components/Auth/AuthDialog";
import { attachHandler } from "../../../../public_html/src/js/components/Auth/AuthPlugin";
import { SGPlugin } from '../../../../public_html/src/js/common/SGPlugins'

declare global {
  namespace CSS {
    // noinspection ES6ConvertVarToLetConst
    var paintWorklet: {
      addModule: (url: string) => Promise<void>
    }
  }
}

export default class AuthPlugin extends SGPlugin {
  name = 'auth'
  fullName = 'Authorization'
  reactive = true
  // noinspection JSUnusedGlobalSymbols
  shouldRun = function (element = document.body): boolean {
    this.elements = Array.from(element.querySelectorAll(this.getSelector()))
    const hasElements = this.elements.length > 0
    const hasUrl = !window.isLoggedIn && window.location.hash.startsWith('#auth/');

    return hasElements || hasUrl;
  }

  run = async () => {
    const elements = this.elements

    if ("paintWorklet" in CSS && !window.squircleInited) {
      window.squircleInited = true
      // noinspection ES6MissingAwait
      CSS.paintWorklet.addModule(
        "https://www.unpkg.com/css-houdini-squircle@0.2.2/squircle.min.js"
      );
    }

    elements.forEach(attachHandler)
  }
}

const hasUrl = !window.isLoggedIn && window.location.hash.startsWith('#auth/')
if (hasUrl) {
  // noinspection JSIgnoredPromiseFromCall
  AuthDialog.show()
}
